module.exports = __webpack_public_path__ + "static/img/image065.4c0cf80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image065.png
// module id = aoga
// module chunks = 1